import { render, staticRenderFns } from "./passwordModal.vue?vue&type=template&id=4db226ab&scoped=true";
import script from "./passwordModal.vue?vue&type=script&lang=js";
export * from "./passwordModal.vue?vue&type=script&lang=js";
import style0 from "./passwordModal.vue?vue&type=style&index=0&id=4db226ab&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4db226ab", null);
export default component.exports;